export async function getProductos(id) {

    return new Promise((resolve) => {
        var datos = [
            { producto: '21310030', url: '21310030-21310033-21310031-21310032' },
            { producto: '21310033', url: '21310030-21310033-21310031-21310032' },
            { producto: '21310032', url: '21310030-21310033-21310031-21310032' },
            { producto: '31310031', url: '21310030-21310033-21310031-21310032' },
            { producto: '29040010', url: '29040010-29040011' },
            { producto: '29040011', url: '29040010-29040011' },
            { producto: '21790006', url: '21790008-21790004-21790003-21790006-21790007-21790005' },
            { producto: '21790003', url: '21790008-21790004-21790003-21790006-21790007-21790005' },
            { producto: '21790008', url: '21790008-21790004-21790003-21790006-21790007-21790005' },
            { producto: '21790004', url: '21790008-21790004-21790003-21790006-21790007-21790005' },
            { producto: '21790005', url: '21790008-21790004-21790003-21790006-21790007-21790005' },
            { producto: '21790007', url: '21790008-21790004-21790003-21790006-21790007-21790005' },
            { producto: '22010001', url: '22010001-22010003-22010002-FILTROS_DE_CAFE' },
            { producto: '22010003', url: '22010001-22010003-22010002-FILTROS_DE_CAFE' },
            { producto: '22010002', url: '22010001-22010003-22010002-FILTROS_DE_CAFE' },
            { producto: '22410001', url: '22010001-22010003-22010002-FILTROS_DE_CAFE' },
            { producto: '29010076', url: 'BOLSA_FLEXIBLE_SIN_IMPRESION_MEDIA_BARRERA_AL_O2_TTE_70_MICRAS' },
            { producto: '29010077', url: 'BOLSA_FLEXIBLE_SIN_IMPRESION_MEDIA_BARRERA_AL_O2_TTE_70_MICRAS' },
            { producto: '29010075', url: 'BOLSA_FLEXIBLE_SIN_IMPRESION_MEDIA_BARRERA_AL_O2_TTE_70_MICRAS' },
            { producto: '29010068', url: 'BOLSA_FLEXIBLE_SIN_IMPRESION_MEDIA_BARRERA_AL_O2_TTE_70_MICRAS' },
            { producto: '29010063', url: 'BOLSA_FLEXIBLE_SIN_IMPRESION_MEDIA_BARRERA_AL_O2_TTE_70_MICRAS' },
            { producto: '29010071', url: 'BOLSA_FLEXIBLE_SIN_IMPRESION_MEDIA_BARRERA_AL_O2_TTE_70_MICRAS' },
            { producto: '29010060', url: 'BOLSA_FLEXIBLE_SIN_IMPRESION_MEDIA_BARRERA_AL_O2_TTE_70_MICRAS' },
            { producto: '29010086', url: 'BOLSA_FLEXIBLE_SIN_IMPRESION_MEDIA_BARRERA_AL_O2_TTE_70_MICRAS' },
            { producto: '29010062', url: 'BOLSA_FLEXIBLE_SIN_IMPRESION_MEDIA_BARRERA_AL_O2_TTE_70_MICRAS' },
            { producto: '29010059', url: 'BOLSA_FLEXIBLE_SIN_IMPRESION_MEDIA_BARRERA_AL_O2_TTE_70_MICRAS' },
            { producto: '29010069', url: 'BOLSA_FLEXIBLE_SIN_IMPRESION_MEDIA_BARRERA_AL_O2_TTE_70_MICRAS' },
            { producto: '29010100', url: 'BOLSA_FLEXIBLE_SIN_IMPRESION_MEDIA_BARRERA_AL_O2_TTE_70_MICRAS' },
            { producto: '29010074', url: 'BOLSA_FLEXIBLE_SIN_IMPRESION_MEDIA_BARRERA_AL_O2_TTE_70_MICRAS' },
            { producto: '29010061', url: 'BOLSA_FLEXIBLE_SIN_IMPRESION_MEDIA_BARRERA_AL_O2_TTE_70_MICRAS' },
            { producto: '29010067', url: 'BOLSA_FLEXIBLE_SIN_IMPRESION_MEDIA_BARRERA_AL_O2_TTE_70_MICRAS' },
            { producto: '29010070', url: 'BOLSA_FLEXIBLE_SIN_IMPRESION_MEDIA_BARRERA_AL_O2_TTE_70_MICRAS' },
            { producto: '29010097', url: 'BOLSA_FLEXIBLE_SIN_IMPRESION_MEDIA_BARRERA_AL_O2_TTE_70_MICRAS' },
            { producto: '29010058', url: 'BOLSA_FLEXIBLE_SIN_IMPRESION_MEDIA_BARRERA_AL_O2_TTE_70_MICRAS' },
            { producto: '29010137', url: 'BOLSA_FLEXIBLE_SIN_IMPRESION_MEDIA_BARRERA_AL_O2_TTE_70_MICRAS' },
            { producto: '29010066', url: 'BOLSA_FLEXIBLE_SIN_IMPRESION_MEDIA_BARRERA_AL_O2_TTE_70_MICRAS' },
            { producto: '29010095', url: 'BOLSA_FLEXIBLE_SIN_IMPRESION_MEDIA_BARRERA_AL_O2_TTE_70_MICRAS' },
            { producto: '11140001', url: '11140002_-_11140001_-_11140003_-_CENTRALES_EFICIENTES_FLEXICOMBI' },
            { producto: '22230001', url: '22230001-29000089-22420001' },
            { producto: '11180008', url: '11180008' },
            { producto: '11180006', url: '11180006' },
            { producto: '11180021', url: '11180021' },
            { producto: '21500007', url: '21500004-21500006-21500003-21500007' },
            { producto: '21500003', url: '21500004-21500006-21500003-21500007' },
            { producto: '21500004', url: '21500004-21500006-21500003-21500007' },
            { producto: '21500006', url: '21500004-21500006-21500003-21500007' },
            { producto: '31280085', url: '31280086_-_31280085_-_31280084_-_MANGAS_PASTELERAS_DE_NYLON' },
            { producto: '31280086', url: '31280086_-_31280085_-_31280084_-_MANGAS_PASTELERAS_DE_NYLON' },
            { producto: '31280084', url: '31280086_-_31280085_-_31280084_-_MANGAS_PASTELERAS_DE_NYLON' },
            { producto: '21500011', url: '21500011-21500010-21500001-21500009' },
            { producto: '21500010', url: '21500011-21500010-21500001-21500009' },
            { producto: '21500001', url: '21500011-21500010-21500001-21500009' },
            { producto: '21500009', url: '21500011-21500010-21500001-21500009' },
            { producto: '29010099', url: 'BOLSA_FLEXIBLE_SIN_IMPRESION_MEDIA_BARRERA_AL_O2_TTE_70_MICRAS' },
            { producto: '29010064', url: 'BOLSA_FLEXIBLE_SIN_IMPRESION_MEDIA_BARRERA_AL_O2_TTE_70_MICRAS' },
            { producto: '29010065', url: 'BOLSA_FLEXIBLE_SIN_IMPRESION_MEDIA_BARRERA_AL_O2_TTE_70_MICRAS' },
            { producto: '21040039', url: 'CLIPS-LORENZO-BARROSO-CARRETE-TIRAS' },
            { producto: '21040002', url: 'CLIPS-LORENZO-BARROSO-CARRETE-TIRAS' },
            { producto: '21040008', url: 'CLIPS-LORENZO-BARROSO-CARRETE-TIRAS' },
            { producto: '21040047', url: 'CLIPS-LORENZO-BARROSO-CARRETE-TIRAS' },
            { producto: '21040006', url: 'CLIPS-LORENZO-BARROSO-CARRETE-TIRAS' },
            { producto: '21040022', url: 'CLIPS-LORENZO-BARROSO-CARRETE-TIRAS' },
            { producto: '21040036', url: 'CLIPS-LORENZO-BARROSO-CARRETE-TIRAS' },
            { producto: '21040040', url: 'CLIPS-LORENZO-BARROSO-CARRETE-TIRAS' },
            { producto: '21040037', url: 'CLIPS-LORENZO-BARROSO-CARRETE-TIRAS' },
            { producto: '21040028', url: 'CLIPS-LORENZO-BARROSO-CARRETE-TIRAS' },
            { producto: '21040027', url: 'CLIPS-LORENZO-BARROSO-CARRETE-TIRAS' },
            { producto: '21040029', url: 'CLIPS-LORENZO-BARROSO-CARRETE-TIRAS' },
            { producto: '21040021', url: 'CLIPS-LORENZO-BARROSO-CARRETE-TIRAS' },
            { producto: '21040030', url: 'CLIPS-LORENZO-BARROSO-CARRETE-TIRAS' },
            { producto: '21040007', url: 'CLIPS-LORENZO-BARROSO-CARRETE-TIRAS' },
            { producto: '21040044', url: 'CLIPS-LORENZO-BARROSO-CARRETE-TIRAS' },
            { producto: '21040003', url: 'CLIPS-LORENZO-BARROSO-CARRETE-TIRAS' },
            { producto: '21040032', url: 'CLIPS-LORENZO-BARROSO-CARRETE-TIRAS' },
            { producto: '21040004', url: 'CLIPS-LORENZO-BARROSO-CARRETE-TIRAS' },
            { producto: '21040023', url: 'CLIPS-LORENZO-BARROSO-CARRETE-TIRAS' },
            { producto: '21040009', url: 'CLIPS-LORENZO-BARROSO-CARRETE-TIRAS' },
            { producto: '21040010', url: 'CLIPS-LORENZO-BARROSO-CARRETE-TIRAS' },
            { producto: '21040045', url: 'CLIPS-LORENZO-BARROSO-CARRETE-TIRAS' },
            { producto: '21040014', url: 'CLIPS-LORENZO-BARROSO-CARRETE-TIRAS' },
            { producto: '21040012', url: 'CLIPS-LORENZO-BARROSO-CARRETE-TIRAS' },
            { producto: '21040016', url: 'CLIPS-LORENZO-BARROSO-CARRETE-TIRAS' },
            { producto: '21040035', url: 'CLIPS-LORENZO-BARROSO-CARRETE-TIRAS' },
            { producto: '21040017', url: 'CLIPS-LORENZO-BARROSO-CARRETE-TIRAS' },
            { producto: '21040020', url: 'CLIPS-LORENZO-BARROSO-CARRETE-TIRAS' },
            { producto: '21040026', url: 'CLIPS-LORENZO-BARROSO-CARRETE-TIRAS' },
            { producto: '21040033', url: 'CLIPS-LORENZO-BARROSO-CARRETE-TIRAS' },
            { producto: '21040034', url: 'CLIPS-LORENZO-BARROSO-CARRETE-TIRAS' },
            { producto: '21040005', url: 'CLIPS-LORENZO-BARROSO-CARRETE-TIRAS' },
            { producto: '21040013', url: 'CLIPS-LORENZO-BARROSO-CARRETE-TIRAS' },
            { producto: '21040001', url: 'CLIPS-LORENZO-BARROSO-CARRETE-TIRAS' },
            { producto: '21040011', url: 'CLIPS-LORENZO-BARROSO-CARRETE-TIRAS' },
            { producto: '21040046', url: 'CLIPS-LORENZO-BARROSO-CARRETE-TIRAS' },
            { producto: '21040015', url: 'CLIPS-LORENZO-BARROSO-CARRETE-TIRAS' },
            { producto: '21040018', url: 'CLIPS-LORENZO-BARROSO-CARRETE-TIRAS' },
            { producto: '21040019', url: 'CLIPS-LORENZO-BARROSO-CARRETE-TIRAS' },
            { producto: '21040031', url: 'CLIPS-LORENZO-BARROSO-CARRETE-TIRAS' },
            { producto: '31100001', url: 'AZAFATES_EN_POLICARBONATOACERO_INOXIDABLE_1' },
            { producto: '31100002', url: 'AZAFATES_EN_POLICARBONATOACERO_INOXIDABLE_1' },
            { producto: '31100010', url: 'AZAFATES_EN_POLICARBONATOACERO_INOXIDABLE_1' },
            { producto: '31100034', url: 'AZAFATES_EN_POLICARBONATOACERO_INOXIDABLE_1' },
            { producto: '31100005', url: 'AZAFATES_EN_POLICARBONATOACERO_INOXIDABLE_1' },
            { producto: '31100033', url: 'AZAFATES_EN_POLICARBONATOACERO_INOXIDABLE_1' },
            { producto: '31100028', url: 'AZAFATES_EN_POLICARBONATOACERO_INOXIDABLE_1' },
            { producto: '31100027', url: 'AZAFATES_EN_POLICARBONATOACERO_INOXIDABLE_1' },
            { producto: '31100023', url: 'AZAFATES_EN_POLICARBONATOACERO_INOXIDABLE_1' },
            { producto: '31100029', url: 'AZAFATES_EN_POLICARBONATOACERO_INOXIDABLE_1' },
            { producto: '31100004', url: 'AZAFATES_EN_POLICARBONATO_ACERO_INOXIDABLE-2' },
            { producto: '31100011', url: 'AZAFATES_EN_POLICARBONATOACERO_INOXIDABLE_1' },
            { producto: '31100035', url: 'AZAFATES_EN_POLICARBONATO_ACERO_INOXIDABLE-2' },
            { producto: '31100038', url: 'AZAFATES_EN_POLICARBONATOACERO_INOXIDABLE_1' },
            { producto: '31100017', url: 'AZAFATES_EN_POLICARBONATOACERO_INOXIDABLE_1' },
            { producto: '21170021', url: 'DISCOS_MOLINO' },
            { producto: '21170022', url: 'DISCOS_MOLINO' },
            { producto: '21170023', url: 'DISCOS_MOLINO' },
            { producto: '21170024', url: 'DISCOS_MOLINO' },
            { producto: '21170025', url: 'DISCOS_MOLINO' },
            { producto: '21170026', url: 'DISCOS_MOLINO' },
            { producto: '21170027', url: 'DISCOS_MOLINO' },
            { producto: '21170028', url: 'DISCOS_MOLINO' },
            { producto: '21170029', url: 'DISCOS_MOLINO' },
            { producto: '21170030', url: 'DISCOS_MOLINO' },
            { producto: '31170001', url: 'DISCOS_MOLINO' },
            { producto: '21170046', url: 'DISCOS_MOLINO' },
            { producto: '21170032', url: 'DISCOS_MOLINO' },
            { producto: '21170033', url: 'DISCOS_MOLINO' },
            { producto: '21170034', url: 'DISCOS_MOLINO' },
            { producto: '21170035', url: 'DISCOS_MOLINO' },
            { producto: '21170036', url: 'DISCOS_MOLINO' },
            { producto: '21170037', url: 'DISCOS_MOLINO' },
            { producto: '21170038', url: 'DISCOS_MOLINO' },
            { producto: '21170039', url: 'DISCOS_MOLINO' },
            { producto: '21170005', url: 'DISCOS-MOLINO' },
            { producto: '21170001', url: 'DISCOS-MOLINO' },
            { producto: '21170002', url: 'DISCOS-MOLINO' },
            { producto: '21170007', url: 'DISCOS-MOLINO' },
            { producto: '21540016', url: 'DISCOS-MOLINO' },
            { producto: '21170003', url: 'DISCOS-MOLINO' },
            { producto: '21170004', url: 'DISCOS-MOLINO' },
            { producto: '21170013', url: 'DISCOS-MOLINO' },
            { producto: '21170049', url: 'DISCOS-MOLINO' },
            { producto: '21170050', url: 'DISCOS-MOLINO' },
            { producto: '21170012', url: 'DISCOS-MOLINO' },
            { producto: '21170048', url: 'DISCOS-MOLINO' },
            { producto: '21170019', url: 'DISCOS-MOLINO' },
            { producto: '21170063', url: 'DISCOS-MOLINO' },
            { producto: '21170047', url: 'CUCHILLA_MOLINO' },
            { producto: '21170008', url: 'CUCHILLA_MOLINO' },
            { producto: '21170009', url: 'CUCHILLA_MOLINO' },
            { producto: '21170040', url: 'CUCHILLA_MOLINO' },
            { producto: '21170020', url: 'CUCHILLA_MOLINO' },
            { producto: '21170018', url: 'CUCHILLA_MOLINO' },
            { producto: '21170031', url: 'CUCHILLA_MOLINO' },
            { producto: '21170052', url: 'CUCHILLA_MOLINO' },
            { producto: '21170055', url: 'CUCHILLA_MOLINO' },
            { producto: '21170054', url: 'CUCHILLA_MOLINO' },
            { producto: '21170057', url: 'CUCHILLA_MOLINO' },
            { producto: '21880006', url: '21880006_-_21880002_-_21880004_-_21880005_-_PROTECTOR_DE_BRAZOS' },
            { producto: '21880002', url: '21880006_-_21880002_-_21880004_-_21880005_-_PROTECTOR_DE_BRAZOS' },
            { producto: '21880004', url: '21880006_-_21880002_-_21880004_-_21880005_-_PROTECTOR_DE_BRAZOS' },
            { producto: '21880005', url: '21880006_-_21880002_-_21880004_-_21880005_-_PROTECTOR_DE_BRAZOS' },
            { producto: '31020012', url: 'DISCOS-PROCESADOR-DE-ALIMENTOS' },
            { producto: '31020014', url: 'DISCOS-PROCESADOR-DE-ALIMENTOS' },
            { producto: '31020005', url: 'DISCOS-PROCESADOR-DE-ALIMENTOS' },
            { producto: '31020002', url: 'DISCOS-PROCESADOR-DE-ALIMENTOS' },
            { producto: '31100003', url: 'https://cdn.shopify.com/s/files/1/0538/6354/7062/files/AZAFATES_EN_POLICARBONATO_ACERO_INOXIDABLE' },
            { producto: '31100002', url: 'https://cdn.shopify.com/s/files/1/0538/6354/7062/files/AZAFATES_EN_POLICARBONATO_ACERO_INOXIDABLE-2' },
            { producto: '29000052', url: '29000052-29000050-29000064' },
            { producto: '29000050', url: '29000052-29000050-29000064' },
            { producto: '29000064', url: '29000052-29000050-29000064' },
            { producto: '29000054', url: '29000054-29000056-29000127' },
            { producto: '29000056', url: '29000054-29000056-29000127' },
            { producto: '29000127', url: '29000054-29000056-29000127' },
            { producto: '21270026', url: '21270024-21270026' },
            { producto: '21270024', url: '21270024-21270026' },
            { producto: '21360021', url: 'ROLLO-PRECORTADO-PEEL-STICK' },
            { producto: '21360029', url: 'ROLLO-PRECORTADO-PEEL-STICK' },
            { producto: '21360027', url: 'ROLLO-PRECORTADO-PEEL-STICK' },
            { producto: '21360012', url: 'ROLLO-PRECORTADO-PEEL-STICK' },
            { producto: '21360035', url: 'ROLLO-PRECORTADO-PEEL-STICK' },
            { producto: '21360022', url: 'ROLLO-PRECORTADO-PEEL-STICK' },
            { producto: '21360017', url: 'ROLLO-PRECORTADO-PEEL-STICK' },
            { producto: '21360014', url: 'ROLLO-PRECORTADO-PEEL-STICK' },
            { producto: '21360016', url: 'ROLLO-PRECORTADO-PEEL-STICK' },
            { producto: '31100030', url: 'TAPA_PARA_AZAFATES_EN_POLICARBONATO-ACERO_INOXIDABLE' },
            { producto: '31100032', url: 'TAPA_PARA_AZAFATES_EN_POLICARBONATO-ACERO_INOXIDABLE' },
            { producto: '31100018', url: 'TAPA_PARA_AZAFATES_EN_POLICARBONATO-ACERO_INOXIDABLE' },
            { producto: '31100025', url: 'TAPA_PARA_AZAFATES_EN_POLICARBONATO-ACERO_INOXIDABLE' },
            { producto: '31100008', url: 'TAPA_PARA_AZAFATES_EN_POLICARBONATO-ACERO_INOXIDABLE' },
            { producto: '31280051', url: '31280051-31280052-31280053' },
            { producto: '31280052', url: '31280051-31280052-31280053' },
            { producto: '31280053', url: '31280051-31280052-31280053' },
            { producto: '19020083', url: 'Mezclador_MD_500_MD1000_MD_1500_MD_2000' },
            { producto: '31100007', url: 'TAPA_PARA_AZAFATES_EN_POLICARBONATO-ACERO_INOXIDABLE' },
            { producto: '29040012', url: '29040012-29040003-29040004' },
            { producto: '29040003', url: '29040012-29040003-29040004' },
            { producto: '29040004', url: '29040012-29040003-29040004' },
            { producto: '31020013', url: 'DISCOS-PROCESADOR-DE-ALIMENTOS' },
            { producto: '39000007', url: '39000007-39000006-39000005' },
            { producto: '39000006', url: '39000007-39000006-39000005' },
            { producto: '39000005', url: '39000007-39000006-39000005' },
            { producto: '29050004', url: '29050003-29050004' },
            { producto: '29050003', url: '29050003-29050004' },
            { producto: '31020029', url: 'DISCOS-PROCESADOR-DE-ALIMENTOS' },
            { producto: '21390010', url: 'CINTA-C-CBT-322-422' },
            { producto: '21390002', url: 'CINTA-C-CBT-322-422' },
            { producto: '21390011', url: 'CINTA-C-CBT-322-422' },
            { producto: '21390031', url: 'CINTA-C-CBT-322-422' },
            { producto: '21390012', url: 'CINTA-C-CBT-322-422' },
            { producto: '21390032', url: 'CINTA-C-CBT-322-422' },
            { producto: '21390014', url: 'CINTA-C-CBT-322-422' },
            { producto: '21390015', url: 'CINTA-C-CBT-322-422' },
            { producto: '21390016', url: 'CINTA-C-CBT-322-422' },
            { producto: '21390033', url: 'CINTA-C-CBT-322-422' },
            { producto: '21390017', url: 'CINTA-C-CBT-322-422' },
            { producto: '21390028', url: 'CINTA-C-CBT-322-422' },
            { producto: '21390027', url: 'CINTA-C-CBT-322-422' },
            { producto: '21390029', url: 'CINTA-C-CBT-322-422' },
            { producto: '21390004', url: 'CINTA-C-CBT-322-422' },
            { producto: '21390006', url: 'CINTA-C-CBT-322-422' },
            { producto: '21390008', url: 'CINTA-C-CBT-322-422' },
            { producto: '21390025', url: 'CINTA-C-CBT-322-422' },
            { producto: '21390030', url: 'CINTA-C-CBT-322-422' },
            { producto: '21390035', url: 'CINTA-C-CBT-322-422' },
            { producto: '21390003', url: 'CINTA-C-CBT-322-422' },
            { producto: '21390023', url: 'CINTA-C-CBT-322-422' },
            { producto: '21390001', url: 'CINTA-C-CBT-322-422' },
            { producto: '21390034', url: 'CINTA-C-CBT-322-422' },
            { producto: '21390019', url: 'CINTA-C-CBT-322-422' },
            { producto: '21390020', url: 'CINTA-C-CBT-322-422' },
            { producto: '21390021', url: 'CINTA-C-CBT-322-422' },
            { producto: '21390022', url: 'CINTA-C-CBT-322-422' },
            { producto: '21390026', url: 'CINTA-C-CBT-322-422' },
            { producto: '21390018', url: 'CINTA-C-CBT-322-422' },
            { producto: '31020021', url: 'DISCOS-PROCESADOR-DE-ALIMENTOS' },
            { producto: '29000021', url: 'ROLLOS_BEDFORD' },
            { producto: '29010192', url: '29010192-29010209' },
            { producto: '29010209', url: '29010192-29010209' },
            { producto: '21360060', url: 'ROLLOS_BEDFORD' },
            { producto: '21360059', url: 'ROLLOS_BEDFORD' },
            { producto: '21360026', url: 'ROLLOS_BEDFORD' },
            { producto: '21360057', url: 'ROLLOS_BEDFORD' },
            { producto: '21360058', url: 'ROLLOS_BEDFORD' },
            { producto: '21360009', url: 'ROLLOS_BEDFORD' },
            { producto: '21360025', url: 'ROLLOS_BEDFORD' },
            { producto: '21360042', url: 'ROLLOS_BEDFORD' },
            { producto: '21360043', url: 'ROLLOS_BEDFORD' },
            { producto: '21360050', url: 'ROLLOS_BEDFORD' },
            { producto: '21360046', url: 'ROLLOS_BEDFORD' },
            { producto: '21360044', url: 'ROLLOS_BEDFORD' },
            { producto: '21360045', url: 'ROLLOS_BEDFORD' },
            { producto: '21040093', url: 'CLIPS-LORENZO-BARROSO-CARRETE-TIRAS' },
            { producto: '31140009', url: '31140009-31140004' },
            { producto: '31140004', url: '31140009-31140004' },
        ]
        var proveedor = false;
        var url = id
        datos.forEach(element => {
            if (element.producto === id) {
                proveedor = true;
                url = element.url
            }
        });

        if (proveedor) {
            resolve(url)
        } else {
            resolve(url)
        }
    })


}